{
  "el": {
    "analytics": {
      "labels": {
        "allUnits": "Όλα τα ακίνητα",
        "click_seen_by": "Κάνε κλικ για περισσότερες πληροφορίες",
        "click_shared_with": "Κάνε κλικ για να δεις ποιοι πελάτες το έχουν δει",
        "deleted": "Διαγράφηκε",
        "deleted_item": "Αυτό το στοιχείο έχει διαγραφεί και δεν μπορείς πλέον να κάνεις κλικ σε αυτό",
        "noCustomers": "Δεν έχουν ανατεθεί ακόμα πελάτες σε αυτό το επίπεδο.",
        "noCustomersSeen": "Κανένας πελάτης δεν το έχει δει ακόμα.",
        "noCustomersUnseen": "Όλοι οι πελάτες το έχουν δει.",
        "noUnitAccess": "Χωρίς πρόσβαση σε ακίνητο",
        "notSeen": "Δεν προβλήθηκε ({number})",
        "seen": "Προβλήθηκε ({number})",
        "seenAt": "Προβλήθηκε: {date}",
        "seenBy": "Προβλήθηκε από",
        "seen_by_all": "Το είδαν όλοι. Κάνε κλικ για να δεις ποιοι το είδαν.",
        "sharedWithMultipleUnits": "Δεν έχει κοινοποιηθεί σε κανένα ακίνητο στο επίπεδο «{level_name}» | Έχει κοινοποιηθεί σε 1 ακίνητο στο επίπεδο «{level_name}» | Έχει κοινοποιηθεί σε {units_count} ακίνητα στο επίπεδο «{level_name}»",
        "sharedWithUnit": "Κοινοποιήθηκε στο ακίνητο «{unit_name}»",
        "units": "Κανένα ακίνητο | 1 ακίνητο | {count} ακίνητα",
        "unseenOfTotal": "{unseen} από {total} δεν το έχουν δει ακόμα",
        "views": "Προβολές",
        "viewsCount": "Καμία προβολή | 1 προβολή | {count} προβολές",
        "whoSeenAnnouncement": "Ποιοι έχουν δει αυτή την ανακοίνωση"
      }
    }
  }
}
